import React, { useState, useEffect } from "react";
import IntlMessages from "@util/IntlMessages";
import SettingsModal from "components/Modal/SettingsModal";
import ListTabs from "components/Widgets/WidgetsSettings/ListSettings/ListTabs";
import ListProfileSelector from "./ListProfileSelector";
import { ListScripts } from "./listScripts";
import { CSVLink } from "react-csv";
import "./mapComponent.less";
import "../list.less";
import { Button, Switch } from "../../../BP2Components";

const ListExtraSettings = ({
   transport,
   selectedSerieObj,
   isCSVDownloadable,
   profiles,
   setDraggableMode,
   listProps,
   selectedSerie,
   columns,
   isDownloadable,
   downloadPDF,
   selectedRowKeys,
   setProfile,
   selectedProfile,
   isProfileSelectorVisible,
   showDragModeSwitch,
   visibleRows,
   visibleColumns,
}) => {
   const [exportData, setExportData] = useState();

   useEffect(() => {
      if (visibleColumns?.length > 0 && visibleRows?.length > 0) {
         const preparedData = ListScripts.prepareDataToXLSExport(visibleColumns, visibleRows);
         setExportData(preparedData);
      }
   }, [visibleColumns]);

   const isCSVExportByJS = () => {
      return selectedSerieObj.query?.includes("}") || selectedSerieObj.query?.includes("jsExport");
   };

   return (
      <div className="modal-extra">
         {!listProps?.showMap && isProfileSelectorVisible && (
            <div className="profile-selector-container">
               <p className="gx-pl-4">
                  <IntlMessages id="listWidget.profileSelectorLabel" />
               </p>
               <ListProfileSelector
                  profiles={profiles}
                  setProfile={setProfile}
                  selectedProfile={selectedProfile}
                  currentListId={selectedSerieObj.listId}
               />
            </div>
         )}

         {showDragModeSwitch ? (
            <div className="btn-draggable-switch">
               <IntlMessages id="listWidget.draggableSwitch" />
               <Switch
                  style={{ marginLeft: "10px", marginBottom: "5px" }}
                  onChange={(checked) => setDraggableMode(checked)}
               />
            </div>
         ) : null}

         {isDownloadable ? (
            <Button
               buttonType="primary"
               shape="circle"
               icon="download"
               style={{
                  opacity: selectedRowKeys.length === 0 ? 0.5 : null,
                  marginLeft: "13px",
               }}
               onClick={downloadPDF}
            />
         ) : null}

         {isCSVDownloadable && (
            <>
               {isCSVExportByJS() && exportData ? (
                  <CSVLink data={exportData} separator={";"} filename={"raport.xls"}>
                     <span className="span-style gx-text-primary icon icon-backtop"></span>
                  </CSVLink>
               ) : (
                  <p
                     className="span-style gx-text-primary icon icon-backtop"
                     onClick={() => ListScripts.exportToExcelPHP(selectedSerieObj)}
                  ></p>
               )}
            </>
         )}

         {(listProps.role === "OWNER" || listProps.role === "MODERATOR") && (
            <SettingsModal
               widgetName={listProps.widgetName || "List"}
               widgetId={listProps.widgetId}
               icon="setting"
               deleteIcon="true"
               children={
                  <ListTabs
                     {...listProps}
                     selectedSerie={selectedSerie}
                     columns={columns}
                     id={listProps.widgetId}
                  />
               }
            />
         )}
      </div>
   );
};

export default ListExtraSettings;
